<template>
    <section>
        <!--工具条-->
        <el-col :span="24" style="padding-bottom: 0;" size="small">
            <el-form :inline="true" :model="filters" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="角色名称" size="small"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="queryBtn()" size="small" icon="el-icon-search" :disabled="!isAuth('role:list')">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd" size="small" icon="el-icon-plus" :disabled="!isAuth('role:add')">添加角色</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="roles" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;"
            size="small">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
            <el-table-column prop="role" label="角色名称" width="150" align="center"></el-table-column>
            <el-table-column prop="desc" label="备注" min-width="180" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('role:update')">修改</el-button>
                    <el-button size="small" type="text" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('role:del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                :total="total" :current-page.sync="page" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="角色更新" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" size="small">
                <el-form-item label="角色名" prop="role">
                    <el-input v-model="editForm.role" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="desc">
                    <el-input v-model="editForm.desc" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="授权" prop="permissions">
                    <el-tree :data="permissionList" :props="defaultProps" show-checkbox node-key="id" ref="editTree"></el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="角色添加" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" size="small">
                <el-form-item label="角色名" prop="role">
                    <el-input v-model="addForm.role" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="desc">
                    <el-input v-model="addForm.desc" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="授权" prop="permissions">
                    <el-tree :data="permissionList" :props="defaultProps" show-checkbox node-key="id" ref="addTree"></el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {
        getRoleList,
        removeRole,
        modifyRole,
        addRole,
        getPermissionList
    } from '../../../api/api';
    import { isAuth,treeDataTranslate } from '@/utils'

    export default {
        data() {
            return {
                defaultProps: {
                    label:'name',
                    children:'children'
                },
                filters: {
                    name: ''
                },
                permissionList: [],
                roles: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列

                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    role: [
                        { required: true, message: '请输入角色名', trigger: 'blur' }
                    ]
                },
                //编辑界面数据
                editForm: {
                    id: '',
                    role: '',
                    desc: '',
                    permissions: []
                },

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    role: [
                        { required: true, message: '请输入角色名', trigger: 'blur' }]
                },
                //新增界面数据
                addForm: {
                    role: '',
                    desc: '',
                    permissions: []
                }

            }
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
                this.getDataList();
            },
            indexMethod(row) {
                return row + (this.page - 1) * 10 + 1
            },

            //获取角色列表
            getDataList() {
                let para = {
                    page: this.page-1,
                    size: 10,
                    role: this.filters.name,
                };
                this.listLoading = true;
                getRoleList(para).then((res) => {
                    if(res.data.code === 0){
                        this.roles = res.data.roleList.content;
                        this.total = res.data.roleList.totalElements;
                        getPermissionList().then((res) => {
                            if(res.data.code === 0){
                                this.permissionList = treeDataTranslate(res.data.permissionList);
                            }else{
                                this.$message.error("获取角色列表失败，请稍后重新获取")
                            }
                        })
                    }else{
                        this.$message.error("获取角色列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },

          queryBtn(){
            this.page=1;
            this.getDataList();
          },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    let para = {
                        id: row.id
                    };
                    removeRole(para).then((res) => {
                        if (res.data.code === 0) {
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error("删除失败")
                        }
                        this.listLoading = false;
                        this.getDataList();

                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                let checkedkeys = [];
                this.editForm.permissions.forEach(function(v,k){
                   checkedkeys.push(v.id)
                });
                this.$nextTick(() => {
                    this.$refs.editTree.setCheckedKeys(checkedkeys);
                })
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            this.editForm.permissions = this.$refs.editTree.getCheckedNodes();
                            let para = Object.assign({}, this.editForm);
                            modifyRole(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('修改成功');
                                } else {
                                    this.$message.error('修改失败');
                                }
                                this.editLoading = false;
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                this.getDataList();
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            this.addForm.permissions = this.$refs.addTree.getCheckedNodes();
                            let para = Object.assign({}, this.addForm);
                            addRole(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('添加成功');
                                } else {
                                    this.$message.error('添加失败');
                                }
                                this.addLoading = false;
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getDataList();
                            });
                        });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            }
        },
        activated() {
            this.getDataList();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/modules/sys/role.vue